import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2.75c-3.744 0-6.775 3.024-6.775 6.75 0 1.082-.053 2.297-.819 3.424l-.002.004c-.126.183-.236.333-.34.474-.14.189-.267.362-.404.578-.214.334-.346.623-.388.903-.138.904.438 1.62 1.447 2.038 4.28 1.772 10.283 1.772 14.562 0 1.009-.418 1.586-1.134 1.448-2.038-.043-.28-.175-.57-.388-.903a10 10 0 0 0-.404-.578 17 17 0 0 1-.34-.474l-.003-.004c-.766-1.127-.819-2.341-.819-3.424 0-3.726-3.03-6.75-6.775-6.75M3.725 9.5c0-4.559 3.707-8.25 8.275-8.25s8.275 3.691 8.275 8.25c0 1.06.071 1.86.559 2.58.068.098.158.222.256.357.17.234.367.503.515.736.262.41.519.906.607 1.483.287 1.884-1.038 3.104-2.357 3.65-4.646 1.925-11.063 1.925-15.71 0-1.319-.546-2.644-1.766-2.356-3.65.088-.577.344-1.072.606-1.483.149-.233.345-.502.515-.736.099-.135.189-.258.256-.357.488-.72.56-1.52.56-2.58",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.808 18.275a.75.75 0 0 1 .917.532c.37 1.39 1.684 2.443 3.275 2.443s2.906-1.052 3.275-2.443a.75.75 0 0 1 1.45.386c-.547 2.06-2.467 3.557-4.725 3.557s-4.177-1.497-4.725-3.557a.75.75 0 0 1 .533-.918",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }